<template>
  <media-list-edit-content
    v-if="editing"
    :list-id="list.id"
    :list-entries="listEntries"
    :title="list.title"
    :description="list.description"
    :is-ranked="list.isRanked"
    :is-private="list.isPrivate"
    @edits-saved="onEditsSaved"
  ></media-list-edit-content>
  <media-list-view-content
    v-else
    :title="list.title"
    :description="list.description"
    :owner="list.owner"
    :is-ranked="list.isRanked"
    :is-private="list.isPrivate"
    :list-entries="listEntries"
    :page="page"
    :total-pages="totalPages"
    @page-change="handlePageChange"
  ></media-list-view-content>
</template>

<script>
import { get404Route } from "@/util/routeHelpers";
import MediaListViewContent from "@/components/media-list-view-content.vue";
import MediaListEditContent, { LEAVE_CONFIRMATION_MESSAGE } from "@/components/media-list-edit-content.vue";

export default {
  name: "media-list",
  components: { MediaListEditContent, MediaListViewContent },

  computed: {
    editing() {
      return "edit" in this.$route.query;
    },

    totalPages() {
      return Math.floor(this.totalEntries / this.ITEMS_PER_PAGE) + 1;
    },
  },

  data: () => ({
    ITEMS_PER_PAGE: 50,

    page: 1,

    list: {
      id: undefined,
      title: "title loading",
      description: "",
      owner: {},
      isRanked: undefined,
      isPrivate: undefined,
    },

    totalEntries: 0,
    listEntries: [],
  }),

  async mounted() {
    // TODO: Consider moving this to `routeUpdate` or something like that
    this.list.id = this.$route.params.listId;

    try {
      const response = await this.$axios.get(`/v1/lists/${this.list.id}`);
      const list = response.data;

      // Verify username in route matches owner of list
      if (list.owner.username !== this.$route.params.username) {
        // TODO: Consider changing this from 404 to rerouting to correct owner of list
        // This will help reinforce our links if we decide to allow for username updates
        await this.$router.replace(get404Route(this.$route));
      }

      this.list = list;

      await this.loadListEntries(this.list.id);
    } catch (e) {
      if (e.response && e.response.status === 404) {
        await this.$router.replace(get404Route(this.$route));
      } else {
        throw e;
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    if (this.editing) {
      const answer = window.confirm(LEAVE_CONFIRMATION_MESSAGE);
      if (!answer) return false;
    }
    next();
  },

  methods: {
    async loadListEntries(listId) {
      const listEntriesResponse = await this.$axios.get(`/v1/lists/${listId}/entries`, {
        params: {
          offset: (this.page - 1) * this.ITEMS_PER_PAGE,
          limit: this.ITEMS_PER_PAGE,
        },
      });

      this.totalEntries = listEntriesResponse.data.totalCount;
      console.log("Updating list entries");
      this.listEntries = listEntriesResponse.data.items;
      console.log(this.listEntries);
    },

    async handlePageChange(newPage) {
      this.page = newPage;

      await this.loadListEntries(this.list.id);
    },

    async onEditsSaved(event) {
      if (event.title) {
        this.list.title = event.title;
      }
      if (typeof event.description === "string") {
        this.list.description = event.description;
      }
      if (typeof event.isRanked === "boolean") {
        this.list.isRanked = event.isRanked;
      }
      if (typeof event.isPrivate === "boolean") {
        this.list.isPrivate = event.isPrivate;
      }

      await this.loadListEntries(this.list.id);
    },
  },
};
</script>

<style>
.media-list-content {
  .interactions {
    padding: 8px 0;
    display: flex;

    .v-btn {
      border-width: 1px;
      height: 24px;
      text-transform: lowercase;
      font-weight: inherit;
    }

    .select-dense {
      margin-top: 0px;
      margin-bottom: 0px;
      margin-right: 8px;
      max-width: 130px;
    }
    .select-dense:last-of-type {
      margin-right: 0;
    }
  }
}

.media-list-content >>> .interactions >>> .v-btn >>> .v-btn__content {
  color: var(--v-text-lighten1);
}
</style>
